import React, { useState } from 'react';
import { Checkbox } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { updateUser } from '../actions/auth';
import { useConfirmation } from '../Context/ConfirmationContext';

// Renders just the checkbox - the caller wraps it in its own <TableCell>.
// This used to render a full <TableRow><TableCell> here, which meant a <tr>
// ended up nested among the parent row's <td> siblings - invalid table
// markup that broke column alignment.
const UserRow = ({ user, disabled, openSnackbar }) => {
  const [isActive, setIsActive] = useState(user.isActive);
  const dispatch = useDispatch();
  const confirm = useConfirmation();

  const handleCheckboxChange = async () => {
    const action = isActive ? 'inactive' : 'active';
    const confirmUpdate = await confirm({
      title: `Make user ${action}?`,
      message: `The user will be marked as ${action}.`,
      confirmLabel: 'Confirm',
      details: {
        partyType: 'User',
        partyName: user.name,
        extra: user.email,
        status: user.role,
      },
    });
    if (!confirmUpdate) return;
    const nextIsActive = !isActive;
    setIsActive(nextIsActive);
    try {
      await dispatch(updateUser(user._id, { isActive: nextIsActive }, openSnackbar));
    } catch (error) {
      // Roll back the optimistic toggle - the error itself is already
      // shown via openSnackbar inside the updateUser thunk.
      setIsActive(isActive);
    }
  };

  return (
    <Checkbox
      checked={isActive}
      onChange={handleCheckboxChange}
      disabled={disabled}
      style={{ color: '#ef7f1a' }}
      edge="start"
    />
  );
};

export default UserRow;
